import { AiScrubBatchLatestResponse, AiScrubScope, isBatchUiTerminal } from '../../../models';

// Identity of a discovery target. The mount-time discovery in use-ai-scrub-progress fires
// at most once per key; the key re-arms discovery when the award, country, or scope changes
// (SPA route-param navigation reuses the mounted hook instance, so a boolean one-shot would
// never re-fire for the next award/country).
export const buildDiscoveryKey = (scope: AiScrubScope, awardId: number, countryId?: number): string =>
  `${scope}:${awardId}:${countryId ?? ''}`;

interface ShouldDiscoverArgs {
  activeBatchRunId?: string;
  persistedId?: string | null;
  lastDiscoveredKey?: string;
  scope: AiScrubScope;
  awardId: number;
  countryId?: number;
}

// Discover only when neither the store nor sessionStorage already knows a run, the award id has
// arrived, the country scope has its country id, and this exact target has not been discovered yet.
export const shouldDiscover = ({
  activeBatchRunId,
  persistedId,
  lastDiscoveredKey,
  scope,
  awardId,
  countryId,
}: ShouldDiscoverArgs): boolean => {
  if (activeBatchRunId) return false;
  if (persistedId) return false;
  if (!awardId) return false;
  if (scope === 'country-awards' && countryId === undefined) return false;
  return buildDiscoveryKey(scope, awardId, countryId) !== lastDiscoveredKey;
};

// The run id to adopt, or undefined when there is no run (204) or the run is already UI-terminal.
export const adoptionCandidate = (latest?: AiScrubBatchLatestResponse): string | undefined =>
  (!latest || isBatchUiTerminal(latest.state)) ? undefined : latest.batchRunId;
